export default {
    showNavMenu: false,
    rolesAvailable: [],
    rolesOfUser: [],
    items: []
}
